import { render, staticRenderFns } from "./ConservativeTherapyDetails.vue?vue&type=template&id=765f1b26&scoped=true"
import script from "./ConservativeTherapyDetails.vue?vue&type=script&lang=js"
export * from "./ConservativeTherapyDetails.vue?vue&type=script&lang=js"
import style0 from "./ConservativeTherapyDetails.vue?vue&type=style&index=0&id=765f1b26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765f1b26",
  null
  
)

export default component.exports